import {
  Box,
  Divider,
  Flex,
  Heading,
  ListItem,
  Text,
  UnorderedList,
} from "@chakra-ui/react";

const list = [
  {
    title: "Lead Backend Engineer",
    period: "Aug 2022 - present • 2 yr 7 mos",
    company: "homefile • USA (Remote)",
    url: "https://homefile.com/",
    tasks: [
      "Led the development of a REST API from the ground up using NestJS and MongoDB to provide solutions for homeowners' daily challenges.",
      "This project encompassed B2B and B2C applications, implementing various authorization levels tailored to each user group.",
      "Designed and modeled database schemas with Mongoose and MongoDB and integrated third-party services such as Stripe, Google APIs, and SendGrid.",
      "Additionally, incorporated AI-driven solutions to centralize information and enhance customer support.",
    ],
    skills: [
      "Typescript",
      "Nest.js",
      "MongoDB",
      "Stripe",
      "Docker",
      "Anthropic",
      "Sendgrid",
      "API Integrations",
      "CI/CD",
      "GCP",
    ],
  },
  {
    title: "Full Stack Developer",
    period: "Apr 2021 - Aug 2022 • 1 yr 5 mos",
    company: "seedz • Brazil (Remote)",
    url: "https://seedz.ag/",
    tasks: [
      "As a full-stack developer, my role involves spearheading the development of new features using Node.js/TypeScript, establishing integrations with third-party applications, crafting microservices, and designing the architecture for a new application.",
      "I support conducting code reviews and training new developers to maintain high-quality standards.",
      "My expertise utilizes Node.js, NestJS, AWS, Cloud Functions, React, Vue.js, Dremio/Tableau, and TypeScript technologies.",
      "I collaborate closely with a team of developers to drive impactful and innovative solutions.",
    ],
    skills: [
      "Typescript",
      "JavaScript",
      "Strapi CMS",
      "Sendgrid",
      "Docker",
      "Vue.js",
      "MongoDB",
      "API Integrations",
      "Strapi",
      "Node.js",
      "AWS",
      "React.js",
    ],
  },
  {
    title: "Full Stack Developer",
    period: "Jan 2020 - Apr 2021 • 1 yr 5 mos",
    company: "Rock Content • Brazil (Remote)",
    url: "https://rockcontent.com/",
    tasks: [
      "Experienced Full Stack Developer proficient in working with various technologies, including crawlers, Node/TypeScript applications, .NET Core 3+, and PHP.",
      "Skilled in both SQL and NoSQL databases.",
      "Currently handling substantial database migrations from SQL Server and MariaDB to PostgreSQL.",
    ],
    skills: [
      "TypeScript",
      "JavaScript",
      "MongoDB",
      "Vue.js",
      "PostgreSQL",
      "API Integrations",
      "Docker",
      "Node.js",
    ],
  },
  {
    title: "FullStack developer",
    period: "Jun 2019 - Jan 2020 • 8 mos",
    company: "VipCommerce • Brazil",
    url: "https://www.vipcommerce.com.br/",
    tasks: [
      "FullStack developer, mainly backend.",
      "Third-party integrations with Slack, payment gateways, and other tools.",
    ],
    skills: ["JavaScript", "React.js", "Node.js", "PHP "],
  },
  {
    title: "Fullstack Developer",
    period: "May 2018 - Jun 2019 • 1 yr 2 mos",
    company: "Vinteum • Brazil",
    url: "https://vinteum.io/",
    tasks: [
      "Responsible for maintaining a Laravel legacy application (PHP, MySQL, and HTML).",
      "Responsible for developing a new one using a newer stack (Node, react, mongo).",
    ],
    skills: [
      "JavaScript",
      "Node.js",
      "PHP",
      "Laravel",
      "MySQL",
      "MongoDB",
      "React.js",
    ],
  },
  {
    title: "Fullstack developer",
    period: "Dec 2016 - Nov 2017 • 1 yr",
    company: "Teknisa • Belo Horizonte",
    url: "https://www.teknisa.com/",
    tasks: [
      "Development of B2B and B2C applications, mobile MVPs and integration with payment gateways",
    ],
    skills: ["JavaScript", "PHP", "PostgreSQL", "AngularJS "],
  },
];

export const JobListComponent = () => {
  const renderJobs = () => {
    return list.map((j) => {
      return (
        <Box>
          <Heading fontSize={"2xl"} fontFamily={"body"}>
            {j.title} <br />
          </Heading>

          <Text color={"gray"}>{j.period}</Text>

          <a href={j.url} target="_blank">
            <Text color={"blue"}>{j.company}</Text>
          </a>

          <UnorderedList mt={2}>
            {j.tasks.map((t) => (
              <ListItem>{t}</ListItem>
            ))}
          </UnorderedList>

          <Flex direction={"row"} justifyContent={"space-around"} mt={2}>
            {j.skills.map((s) => (
              <Text
                borderRadius={"10"}
                backgroundColor={"#48bb78"}
                textAlign={"center"}
                color={"white"}
                px={3}
              >
                {s}
              </Text>
            ))}
          </Flex>

          <Divider mt={10} bg={"grey.200"} border={2} maxW={"98vw"} />
        </Box>
      );
    });
  };

  return (
    <Flex direction={"column"} justifyContent="center" p={8}>
      {renderJobs()}
    </Flex>
  );
};
